import { QueryBase } from '../QueryBase';
export class FilterStageImpl extends QueryBase {
    constructor(origin) {
        super({
            collectionName: origin?.collectionName || '',
            filterBuilder: origin?.filterBuilder,
        });
    }
    copy(params) {
        return new FilterStageImpl({
            collectionName: this.collectionName,
            filterBuilder: params.filterBuilder || this.filterBuilder,
        });
    }
    get invalidArguments() {
        return [];
    }
    toProto() {
        return { filter: this.filterBuilder.build() };
    }
}
//# sourceMappingURL=FilterStage.js.map